import { GetUserAgentDocument } from '@kijiji/generated/graphql-types'

import { type RequestHeaders } from '@/lib/apollo/apolloClient'

export const getInitialUserAgentCacheData = (headers?: RequestHeaders['headers']) => {
  return {
    query: GetUserAgentDocument,
    data: {
      userAgent: {
        userAgent: headers?.['user-agent'] ?? null,
      },
    },
  }
}
